module.exports = __webpack_public_path__ + "images/ico-server-act.svg?8b6fed879b36f187dd7432fbceb56141";